import YAML from 'yaml';

import { useGitFilePreview } from '@/react/portainer/gitops/queries/useGitFilePreview';

import { GitHelmChartBaseParams } from './useGitHelmChartValues';

type ChartMetadata = {
  name?: string;
  version?: string;
  description?: string;
  apiVersion?: string;
  appVersion?: string;
  type?: string;
};

type GitHelmChartInfoParams = GitHelmChartBaseParams & {
  command: 'chart';
};

/**
 * Parses Chart.yaml from a Git repository and returns chart metadata
 * including version, name, description, etc.
 */
export function useGitHelmChartInfo(
  params: GitHelmChartInfoParams,
  { enabled }: { enabled?: boolean } = {}
) {
  const hasValidGitParams =
    !!params.sourceId && !!params.chartPath && params.command === 'chart';

  return useGitFilePreview(
    {
      targetFile: `${params.chartPath}/Chart.yaml`,
      reference: params.reference || 'refs/heads/main',
      sourceId: params.sourceId,
    },
    {
      enabled: hasValidGitParams && enabled,
      select: (chartYaml) => {
        try {
          const meta = YAML.parse(chartYaml) as ChartMetadata;
          return {
            name: meta?.name || '',
            version: meta?.version || '',
            description: meta?.description || '',
            apiVersion: meta?.apiVersion || '',
            appVersion: meta?.appVersion || '',
            type: meta?.type || '',
          };
        } catch {
          throw new Error('Invalid Chart.yaml format');
        }
      },
    }
  );
}
